import React, { useMemo, useState } from 'react'
import { LogoContainer, Card, Selection } from './styles'
import target from '../../images/retail/target.webp'
import costco from '../../images/retail/costco.png'
import bestBuy from '../../images/retail/best-buy.png'
import sams from '../../images/retail/sams.webp'
import amazon from '../../images/retail/amazon.png'
import walmart from '../../images/retail/walmart.webp'
import currys from '../../images/retail/currys-horizontal.png'
import harveyNorman from '../../images/retail/harvey-norman-horizontal.png'
import selfridges from '../../images/retail/selfridges-yellow.png'
import jbHiFi from '../../images/retail/jb-hifi-yellow.png'
import very from '../../images/retail/uk-very.png'
import { LOCALIZATION } from '../../utils/constants'

const RetailPartners = () => {
  const partnersByLocalization = {
    en: [
      {
        id: 'target',
        name: `Target`,
        link: 'https://www.target.com/p/skylight-10-digital-photo-frame/-/A-89661638?preselect=89566847#lnk=sametab',
        image: target,
        products: ['Frame'],
      },
      {
        id: 'target',
        name: `Target`,
        link: 'https://www.target.com/p/skylight-15-34-touchscreen-smart-calendar-white/-/A-89566848#lnk=sametab',
        image: target,
        products: ['Calendar'],
      },
      {
        id: 'costco',
        name: `Costco`,
        link: 'https://www.costco.com/CatalogSearch?dept=All&keyword=skylight+calendar',
        image: costco,
        products: ['Calendar'],
      },
      {
        id: 'bestbuy',
        name: `Best Buy`,
        link: 'https://www.bestbuy.com/site/skylight-calendar-15-inch-touchscreen-smart-calendar-and-chore-chart-silver/6576718.p?skuId=6576718',
        image: bestBuy,
        products: ['Calendar'],
      },
      {
        id: 'bestbuy',
        name: `Best Buy`,
        link: 'https://www.bestbuy.com/site/skylight-10-wifi-digital-picture-frame-black/6580095.p?skuId=6580095',
        image: bestBuy,
        products: ['Frame'],
      },
      {
        id: 'sams',
        name: `Sam's Club`,
        link: 'https://www.samsclub.com/p/skylight-calendar-15-inch-wifi-digital-calendar/P03021970?xid=plp_product_2',
        image: sams,
        products: ['Calendar'],
      },
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.com/Skylight-Frame-Digital-Picture-Anywhere/dp/B01N7ENHO6?maas=maas_adg_6A193DE8C511CBE09C6CC52D32845E1E_afap_abs&ref_=aa_maas&tag=maas',
        image: amazon,
        products: ['Frame'],
      },
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.com/Skylight-Calendar-Touchscreen-Interactive-Schedules/dp/B0C9V811L6?maas=maas_adg_16B76AF3EC9714D34FE1E6F753F7A2A5_afap_abs&ref_=aa_maas&tag=maas',
        image: amazon,
        products: ['Calendar'],
      },
      {
        id: 'walmart',
        name: `Walmart`,
        link: 'https://www.walmart.com/ip/Skylight-15-Inch-All-In-One-Touchscreen-Family-Calendar-and-Chore-Chart/15961508999?classType=REGULAR&athbdg=L1100&from=/search',
        image: walmart,
        products: ['Calendar'],
      },
    ],
    'en-ca': [
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.ca/Skylight-Plus-10-Photos-Frame/dp/B01N7ENHO6/',
        image: amazon,
        products: ['Frame'],
      },
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.ca/Skylight-15-Inch-Calendar-Touchscreen-Schedules/dp/B0C9V811L6/',
        image: amazon,
        products: ['Calendar'],
      },
      {
        id: 'costco',
        name: `Costco`,
        link: 'https://www.costco.ca/skylight-15-in.-white-smart-touchscreen-calendar-and-organizer.product.4000314771.html',
        image: costco,
        products: ['Calendar'],
      },
      {
        id: 'bestbuy',
        name: `Best Buy`,
        link: 'https://www.bestbuy.ca/en-ca/product/skylight-27-touchscreen-calendar-smart-display-white/19352030',
        image: bestBuy,
        products: ['Calendar'],
      },
    ],
    'en-au': [
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.com.au/Skylight-15-Inch-Calendar-Touchscreen-Schedules/dp/B0C9V811L6/',
        image: amazon,
        products: ['Calendar'],
      },
      {
        id: 'jbhifi',
        name: `JB Hi-Fi`,
        link: 'https://www.jbhifi.com.au/search?query=skylight%20calendar',
        image: jbHiFi,
        products: ['Calendar'],
      },
    ],
    'en-gb': [
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.co.uk/Skylight-Plus-10-Photos-Frame/dp/B01N7ENHO6/',
        image: amazon,
        products: ['Frame'],
      },
      {
        id: 'amazon',
        name: `Amazon`,
        link: 'https://www.amazon.co.uk/Skylight-15-Inch-Calendar-Touchscreen-Schedules/dp/B0C9V811L6/',
        image: amazon,
        products: ['Calendar'],
      },
      {
        id: 'currys',
        name: `Currys`,
        link: 'https://www.currys.co.uk/products/skylight-15-smart-digital-calendar-white-10296309.html',
        image: currys,
        products: ['Calendar'],
      },
      {
        id: 'harveyNorman',
        name: `Harvey Norman`,
        link: 'https://www.harveynorman.co.uk/products/skylight-15-digital-calendar-150rebi?srsltid=AfmBOoqK04SslAIQ_x5HPCUJpLKtQirNIeXlaV2Osn6HO0DLMORw5bF0',
        image: harveyNorman,
        products: ['Calendar'],
      },
      {
        id: 'selfridges',
        name: `Selfridges`,
        link: 'https://www.selfridges.com/US/en/product/smartech-skylight-digital-calendar-15in_R04587967/#colour=WHITE',
        image: selfridges,
        products: ['Calendar'],
      },
      {
        id: 'very',
        name: `Very`,
        link: 'https://www.very.co.uk/skylight-15-inch-smart-digital-calendar/1601322999.prd',
        image: very,
        products: ['Calendar'],
      },
    ],
  }

  const partners = partnersByLocalization[LOCALIZATION] || partnersByLocalization.en
  const availableCategories = useMemo(() => {
    const categories = new Set()
    partners.forEach((partner) => partner.products.forEach((product) => categories.add(product)))
    return Array.from(categories)
  }, [partners])

  const [selectedCategory, setSelectedCategory] = useState(
    availableCategories.includes('Calendar') ? 'Calendar' : availableCategories[0]
  )

  const filteredPartners = partners.filter((partner) => partner.products.includes(selectedCategory))

  const handleSelectionChange = (category) => {
    setSelectedCategory(category)
  }
  return (
    <>
      {availableCategories.length > 1 && (
        <>
          {availableCategories.includes('Frame') && (
            <Selection
              selected={selectedCategory === 'Frame'}
              onClick={() => handleSelectionChange('Frame')}
            >
              Frame
            </Selection>
          )}
          {availableCategories.includes('Calendar') && (
            <Selection
              selected={selectedCategory === 'Calendar'}
              onClick={() => handleSelectionChange('Calendar')}
            >
              Calendar
            </Selection>
          )}
        </>
      )}
      <LogoContainer>
        {filteredPartners.map((partner) => (
          <a
            key={`${partner.id}-${partner.products[0]}`}
            href={partner.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Card>
              <img id={partner.id} src={partner.image} alt={partner.name} />
            </Card>
          </a>
        ))}
      </LogoContainer>
    </>
  )
}

export default RetailPartners
